import { atom } from 'jotai';

import type { TInputSize } from '@endurancewarranty/ui';
import type { ReactNode } from 'react';

export type TSidebarDialogState = Readonly<{
  isOpen: boolean;
  hasCloseButton?: boolean;
  children?: ReactNode;
  size?: TInputSize | 'xl';
  openDirection?: 'right' | 'left' | 'center';
  shouldCloseOnBlur?: boolean;
}>;

export const INITIAL_SIDEBAR_DIALOG_STATE = {
  isOpen: false,
  hasCloseButton: true,
  children: null,
  size: 'sm',
  shouldCloseOnBlur: false,
} satisfies TSidebarDialogState;

// This atom holds the state of the general sidebar dialog component
// on the site.
const sidebarDialogAtom = atom<TSidebarDialogState>(INITIAL_SIDEBAR_DIALOG_STATE);

export { sidebarDialogAtom };
